import { Component } from '@angular/core';

@Component({
	selector: 'seira-indisponivel-mobile',
	templateUrl: './indisponivel-mobile.component.html',
	styleUrls: ['./indisponivel-mobile.component.scss'],
})
export class IndisponivelMobileComponent {}
